import { render, staticRenderFns } from "./topic-content.vue?vue&type=template&id=1ddcf1f8&"
import script from "./topic-content.vue?vue&type=script&lang=js&"
export * from "./topic-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\projects\\tesas_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1ddcf1f8', component.options)
    } else {
      api.reload('1ddcf1f8', component.options)
    }
    module.hot.accept("./topic-content.vue?vue&type=template&id=1ddcf1f8&", function () {
      api.rerender('1ddcf1f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/analysis/topic-content.vue"
export default component.exports